import { region as regionFunctions } from '@sellpy/commons'

/**
 * Since app payments don't have region as env. Do we need to read the
 * region from window for app payments.
 */
export const getRegion = () => {
  if (window.paymentData) {
    const paymentData = JSON.parse(window.paymentData)
    if (paymentData?.region) return paymentData?.region
  }
  return process.env.REGION
}

// Mentioned in media (showed on about-us page)
export const mediaChannels = regionFunctions.mediaChannels(getRegion())

// Cancellation policy link (showed in footer)
export const showCancellationPolicy = regionFunctions.showCancellationPolicy(getRegion())

// External review service on payment and order page
export const externalReviewService = regionFunctions.externalReviewService(getRegion())

export const showTrustScore = regionFunctions.showTrustScore(getRegion())

export const trustPilotLink = regionFunctions.trustPilotLink(getRegion())

export const trustPilotBusinessUnitId = regionFunctions.trustPilotBusinessUnitId(getRegion())

export const ADYEN_PAYMENT_OPTIONS = regionFunctions.adyenPaymentOptions(getRegion())

export const paymentServiceProviders = regionFunctions.paymentServiceProviders(getRegion())

// Check if we should show bank account fields (clearing no. and account no.)
export const internationalBankAccountFields = regionFunctions.internationalBankAccountFields(
  getRegion()
)

// Which postnordMyPackLogo logo to choose, or if we should use postnord partner-logo (for NL, e.g.)
export const postnordMyPackLogo = regionFunctions.postnordMyPackLogo(getRegion())

export const languageLocalisationCode = regionFunctions.languageLocalisationCode(getRegion())

export const defaultAddressOptionalFields = () =>
  regionFunctions.defaultAddressOptionalFields(getRegion())

export const validShippingCountries = regionFunctions.validShippingCountries(getRegion())

export const vatMultiplier = regionFunctions.vatMultiplier(getRegion())

export const supportPhone = regionFunctions.supportPhone(getRegion())

export const company = regionFunctions.company(getRegion())

export const contactAddress = regionFunctions.contactAddress(getRegion())

export const pricingInfoExamples = regionFunctions.pricingInfoExamples(getRegion())

export const nrOfAllowedBagsPerOrder = regionFunctions.nrOfAllowedBagsPerOrder(getRegion())

export const dropOffServicePointsWebsite = regionFunctions.dropOffServicePointsWebsite(getRegion())

export const isLoyaltyEnabled = regionFunctions.isLoyaltyEnabled(getRegion())
